// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PropertySafetyFilledSvg from "@fishx/icons-svg/es/asn/PropertySafetyFilled";
import FishxIcon from '../components/FishxIcon';

var PropertySafetyFilled = function PropertySafetyFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PropertySafetyFilledSvg
  }));
};

PropertySafetyFilled.displayName = 'PropertySafetyFilled';
export default React.forwardRef(PropertySafetyFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PropertySafetyFilled.js
// module id = 3862
// module chunks = 0